import PropTypes from 'prop-types'
import { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter, Redirect } from 'react-router-dom'
import { compose } from 'redux'
import { dispatchSweetAlert } from '../../actions'
import brandit_rails from '../../api/brandit_rails'

const FILE_EXTENSION = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx'
}
/**
 * GridExport component
 *
 * This component is responsible for downloading the excel file generated.
 *
 * @returns {null}
 */
const GridExport = ({ dispatchSweetAlert, match }) => {
  const [isNavigate, setIsNavigate] = useState(false)
  /**
   * downloadFile
   *
   * Downloads the excel file using the params from the URL.
   */
  const downloadFile = useCallback(async () => {
    let isDownloadPromptShown = false
    const id = match.params.id
    try {
      const response = await brandit_rails.get(`/grid_exports/${id}/download`, {
        responseType: 'blob'
      })

      const nameResponse = await brandit_rails.get(`/grid_exports/${id}`)

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      )
      const filename = `${nameResponse.data.name}`

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${filename}.${FILE_EXTENSION[response.headers['content-type']]}`)
      document.body.appendChild(link)
      // Checks if the browser shows a download prompt.
      // If it shows then no need to display a sweet alert.
      window.onblur = () => {
        isDownloadPromptShown = true
        // Cleanup when going back to focus
        window.onfocus = () => {
          setIsNavigate(true)
          document.body.removeChild(link)
          window.onblur = null
        }
      }

      link.click()

      setTimeout(() => {
        if (isDownloadPromptShown) {
          return
        }
        dispatchSweetAlert({
          alerType: 'success',
          title: 'File Downloaded Successfully',
          showCancel: false,
          confirmBtnText: 'OK',
          onConfirm: () => {
            setIsNavigate(true)
          }
        })
        setIsNavigate(true)
        document.body.removeChild(link)
        window.onblur = null
      }, 800)
    } catch (error) {
      dispatchSweetAlert({
        type: 'error',
        title: 'Link Not Found or Expired',
        alertMessage: 'Please generate a new link to download the file.',
        showCancel: false,
        confirmBtnText: 'OK',
        onConfirm: () => {
          setIsNavigate(true)
        }
      })
    }
  }, [dispatchSweetAlert, match.params.id])

  useEffect(() => {
    const regex = /^\/grid_exports\/\d+\/download$/
    if (!regex.test(window.location.pathname)) {
      return
    }
    downloadFile()
  }, [downloadFile])

  return isNavigate ? <Redirect to="/" /> : null
}

GridExport.propTypes = {
  dispatchSweetAlert: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  currentAdmin: state.admins.current_admin
})

const enhance = compose(connect(mapStateToProps, { dispatchSweetAlert }), withRouter)

export default enhance(GridExport)
